import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';
import Animated, {
  useAnimatedStyle,
  withTiming,
  Easing,
  WithTimingConfig,
} from 'react-native-reanimated';

import { useColors } from '@hooks';

const SIZE = 7;

const Dot = styled(View)({
  size: SIZE,
  borderRadius: SIZE / 2,
  bg: '$background20',
});

const AnimatedDot = Animated.createAnimatedComponent(Dot);

const animationConfig: WithTimingConfig = {
  duration: 250,
  easing: Easing.linear,
};

export interface IPaginationDotProps {
  isActive: boolean;
}

export function PaginationDot({ isActive }: IPaginationDotProps) {
  const colors = useColors();

  const animatedDoStyle = useAnimatedStyle(() => {
    return {
      backgroundColor: withTiming(
        isActive ? colors.$primary300 : colors.$background20,
        animationConfig,
      ),
      opacity: withTiming(isActive ? 1 : 0.5, animationConfig),
    };
  });

  return <AnimatedDot style={animatedDoStyle} />;
}
